import * as Constants from '../../constants';
import styles from './LoginForm.module.css';

import { useState } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSignIn,
    faEnvelope,
    faLock,
    faEye,
    faEyeSlash,
    faUserShield,
    faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';

function LoginForm(props) {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    async function handleSubmit(event) {
        event.preventDefault();

        setShowError(false);
        setIsSubmitting(true);

        try {
            const response = await fetch(Constants.LOGIN, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email, password })
            });

            if (response.status === 401 || response.status === 422) {
                setErrorMessage("Email ou senha inválidos.");
                setShowError(true);
                setIsSubmitting(false);
                return;
            }

            if (!response.ok) {
                setErrorMessage("Erro no servidor.");
                setShowError(true);
                setIsSubmitting(false);
                return;
            }

            const data = await response.json();

            if (data?.token) {
                props.onLogin(data);
                navigate('/admin');
            } else {
                setErrorMessage("Não foi possível autenticar.");
                setShowError(true);
            }

        } catch (error) {
            console.log(error);
            setErrorMessage("Falha na conexão com o servidor.");
            setShowError(true);
        }

        setIsSubmitting(false);
    }

    return (
        <Container
            fluid
            className={`d-flex justify-content-center align-items-center ${styles.wrapper}`}
        >
            <Row className="w-100 justify-content-center">
                <Col xs={11} sm={8} md={6} lg={4} xl={3}>
                    <Card className={styles.card}>
                        <div className={styles.accent} />

                        <Card.Body className={styles.body}>

                            <div className={styles.header}>
                                <div className={styles.iconCircle}>
                                    <FontAwesomeIcon icon={faUserShield} />
                                </div>
                                <h4 className={styles.title}>Entrar na sua conta</h4>
                                <p className={styles.subtitle}>
                                    Informe suas credenciais para acessar o painel
                                </p>
                            </div>

                            {showError && (
                                <Alert
                                    variant="danger"
                                    className={styles.alert}
                                    dismissible
                                    onClose={() => setShowError(false)}
                                >
                                    <FontAwesomeIcon icon={faTriangleExclamation} className="me-2" />
                                    {errorMessage}
                                </Alert>
                            )}

                            <Form onSubmit={handleSubmit}>

                                <Form.Group className={styles.group} controlId="login-email">
                                    <Form.Label className={styles.label}>Email</Form.Label>
                                    <div className={styles.field}>
                                        <span className={styles.fieldIcon}>
                                            <FontAwesomeIcon icon={faEnvelope} />
                                        </span>
                                        <Form.Control
                                            className={styles.input}
                                            type="email"
                                            placeholder="seu@email.com"
                                            autoComplete="email"
                                            autoFocus
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                                </Form.Group>

                                <Form.Group className={styles.group} controlId="login-password">
                                    <Form.Label className={styles.label}>Senha</Form.Label>
                                    <div className={styles.field}>
                                        <span className={styles.fieldIcon}>
                                            <FontAwesomeIcon icon={faLock} />
                                        </span>
                                        <Form.Control
                                            className={styles.input}
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Digite sua senha"
                                            autoComplete="current-password"
                                            value={password}
                                            onChange={e => setPassword(e.target.value)}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className={styles.toggle}
                                            onClick={() => setShowPassword(v => !v)}
                                            aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                            tabIndex={-1}
                                        >
                                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                        </button>
                                    </div>
                                </Form.Group>

                                <div className="d-grid mt-3">
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        size="lg"
                                        disabled={isSubmitting}
                                        className={styles.submit}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    className="me-2"
                                                />
                                                Entrando...
                                            </>
                                        ) : (
                                            <>
                                                <FontAwesomeIcon icon={faSignIn} className="me-2" />
                                                Entrar
                                            </>
                                        )}
                                    </Button>
                                </div>

                            </Form>

                            <div className={styles.footer}>
                                <a href=''>
                                    <FontAwesomeIcon icon={faLock} className="me-1" />
                                    Esqueci minha senha
                                </a>
                            </div>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default LoginForm;
